<a [href]="deviceSpecificRedirectUrl" class="d-block d-lg-none card py-3 px-3 col">
  <div class="d-flex">
    <ng-container *ngTemplateOutlet="svg"></ng-container>
    <div class="d-flex flex-column">
      <ng-container *ngTemplateOutlet="messaging"></ng-container>
    </div>
  </div>
</a>

<div class="card p-4 d-none d-lg-block col">
  <div class="d-flex">
    <ng-container *ngTemplateOutlet="svg"></ng-container>
    <div class="d-flex flex-column">
      <ng-container *ngTemplateOutlet="messaging"></ng-container>
      <form [formGroup]="formGroup" (ngSubmit)="onSubmit()" class="d-flex">
        <div class="d-inline-block mr-2">
          <!--ID should exist inside of om-phone-number-input; suppress the IDE warning -->
          <!--suppress XmlInvalidId -->
          <label class="d-block" for="phone-number">Mobile Number</label>
          <om-phone-number-input
            [overrideDisplayError]="true"
            [formControlName]="formControlName"
            (errorMessageEmitter)="setErrorMessage($event)"
            class="d-block"
          ></om-phone-number-input>
        </div>
        <button
          type="submit"
          class="btn btn-outline-primary d-inline-block align-self-end mr-2"
          [disabled]="submitting || submitted"
        >
          {{ buttonText }}
        </button>
        <span class="align-self-end text-danger" *ngIf="formErrorMessage">{{
          formErrorMessage
        }}</span>
      </form>
    </div>
  </div>
</div>

<ng-template #messaging>
  <h3 class="card-title">Download the One Medical app</h3>
  <!-- prettier-ignore -->
  <p class="mb-lg-4 mb-0 card-text">Get access to 24/7 video visits, view your Health Record, and book appointments on our mobile app.</p>
</ng-template>

<ng-template #svg>
  <div class="svg-container mr-4"><om-svg-download-app></om-svg-download-app></div>
</ng-template>
